import * as React from 'react'

import { styled } from '@mui/material/styles'
import CardActionArea from '@mui/material/CardActionArea'
import Stack from '@mui/material/Stack'
import Card from '@mui/material/Card'

import Text from 'components/atomic/atoms/text'
import Image from 'next/image'
import Link from 'next/link'
import Routes from 'utils/routes'

const StyledCard = styled(Card)`
    height: 100%;
    box-shadow: none;
`

const CardContent = styled('div')`
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 1rem;
    justify-content: space-between;
    z-index: 1;
    top: 0;
    left: 0;
    padding: 1rem;
`

interface LanguageCardProps {
    item: {
        _id: string
        slug: string
        title: string
        logo: string
    }
}

const LanguageCard = React.memo(({ item }: LanguageCardProps) => {
    return (
        <Link href={Routes.WikiLanguage(item.slug)}>
            <a>
                <StyledCard>
                    <CardActionArea sx={{ height: '100%' }}>
                        <CardContent>
                            <Stack direction="row" flex={'none'} alignItems="center" height={'100%'} spacing={2}>
                                {item.logo && (
                                    <Image
                                        alt={`${item.title} logo`}
                                        width={50}
                                        height={50}
                                        objectFit="contain"
                                        style={{ opacity: 0.7, flex: 'none' }}
                                        unoptimized={true}
                                        src={item.logo}
                                    />
                                )}
                                <Text variant="h6" flex={'none'} overflow="ellipsis">
                                    {item.title}
                                </Text>
                            </Stack>
                        </CardContent>
                    </CardActionArea>
                </StyledCard>
            </a>
        </Link>
    )
})

export default LanguageCard
